import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { LazyMotion, domAnimation, m } from "framer-motion";
const HERO_IMAGES = [
  "/images/Hiru/Hiru Villa's/Drone/DJI_0950-Enhanced-NR-Pano-1-copy.webp",
  "/images/OM Edited/DSC02396.webp",
  "/images/Hiru/public_images/680A2315-Enhanced-NR-2-Edit-copy.webp",
  "/images/Hiru/public_images/680A2487-Enhanced-NR-copy.webp",
  "/images/Hiru/public_images/Shirodara-scaled-e1734861147958.avif"
];
const HERO_HEADLINE_ANIMATION = {
  initial: { opacity: 0, y: 50 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] }
};
const HERO_DESCRIPTION_ANIMATION = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { delay: 0.5, duration: 1, ease: [0.22, 1, 0.36, 1] }
};
const CTA_BASE_CLASS = "group relative inline-flex items-center justify-center overflow-hidden rounded-full px-10 py-4 text-base font-semibold tracking-wide transition-all duration-500 sm:px-12 sm:py-5 sm:text-lg active:scale-[0.985]";
const HomeHeroVideo = () => {
  const [activeImage, setActiveImage] = useState(0);
  useEffect(() => {
    const imageRotation = window.setInterval(() => {
      setActiveImage((currentImage) => (currentImage + 1) % HERO_IMAGES.length);
    }, 5500);
    return () => window.clearInterval(imageRotation);
  }, []);
  useEffect(() => {
    const nextImage = new window.Image();
    nextImage.src = HERO_IMAGES[(activeImage + 1) % HERO_IMAGES.length];
  }, [activeImage]);
  return <section className="relative flex h-[100svh] min-h-[560px] w-full items-center justify-center overflow-hidden">
            {
    /* Background Image */
  }
            <div className="absolute inset-0">
                <img
    key={HERO_IMAGES[activeImage]}
    src={HERO_IMAGES[activeImage]}
    alt="Hintergrundbild des Hiru Resorts"className="object-cover" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="eager" fetchPriority="high" />
            </div>

            {
    /* Black transparent overlays keep the changing images behind the content. */
  }
            <div className="absolute inset-0 z-10 bg-black/50" />
            <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/40 via-transparent to-black/50" />

            {
    /* Content Container */
  }
            <LazyMotion features={domAnimation}>
                <div className="relative z-20 flex w-full flex-col items-center justify-center px-6 text-center sm:px-8">
                    {
    /* Optional Logo / Emblem - Elevated */
  }
                    <m.div
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 1.2, ease: "easeOut" }}
    className="mb-8"
  >
                        <div className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-white/40 bg-white/10 backdrop-blur-xl shadow-xl">
                            <span className="text-2xl font-serif text-white tracking-widest">Hiru</span>
                        </div>
                    </m.div>

                    {
    /* Headline */
  }
                    <m.div
    initial={HERO_HEADLINE_ANIMATION.initial}
    animate={HERO_HEADLINE_ANIMATION.animate}
    transition={HERO_HEADLINE_ANIMATION.transition}
    className="mb-6 flex flex-col items-center"
  >
                        <h1 className="font-serif text-[2.85rem] font-light leading-none tracking-[-0.04em] text-white drop-shadow-2xl sm:text-6xl md:text-7xl lg:text-[5.5rem] xl:text-[6.2rem]">
                            Hiru Resorts
                        </h1>
                    </m.div>

                    {
    /* Description */
  }
                    <m.p
    initial={HERO_DESCRIPTION_ANIMATION.initial}
    animate={HERO_DESCRIPTION_ANIMATION.animate}
    transition={HERO_DESCRIPTION_ANIMATION.transition}
    className="mx-auto mb-12 max-w-2xl text-balance text-[17px] leading-relaxed text-white/90 sm:text-xl md:text-2xl"
  >
                        Umgeben von der Sonne und dem Meer Sri Lankas, findet der Geist und der Körper<br className="hidden sm:block" />
                        zu einer echten Ayurveda-Erfahrung
                    </m.p>

                    {
    /* CTAs - More Refined */
  }
                    <div className="flex w-full flex-col items-center gap-4 sm:w-auto sm:flex-row sm:gap-6">
                        <Link
    to="/about"
    className={`${CTA_BASE_CLASS} bg-[#F28600] text-white shadow-2xl hover:bg-[#e07a00] hover:shadow-3xl hover:-translate-y-0.5`}
  >
                            Mehr über unsere Geschichte
                            <span className="ml-2 transition-transform group-hover:translate-x-1">→</span>
                        </Link>

                        <Link
    to="/contact-us"
    className={`${CTA_BASE_CLASS} border-2 border-white/90 bg-transparent text-white hover:bg-white/10 hover:text-white hover:border-white hover:-translate-y-0.5`}
  >
                            Kontakt
                        </Link>
                    </div>

                    {
    /* Trust Indicators */
  }
                    <m.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: 1.2 }}
    className="absolute bottom-12 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-1 text-[10px] tracking-widest text-white/60 sm:flex"
  >

                    </m.div>
                </div>
            </LazyMotion>

            {
    /* Scroll Prompt */
  }
            <m.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: 1.8 }}
    className="absolute bottom-8 left-1/2 z-30 hidden -translate-x-1/2 flex-col items-center sm:flex"
  >
                <div className="text-[10px] font-light tracking-[2px] text-white mb-2">WEITER SCROLLEN</div>
                <div className="h-10 w-[1px] bg-gradient-to-b from-transparent via-white/40 to-transparent" />
            </m.div>
        </section>;
};
export default HomeHeroVideo;
